(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-categories-slider"] && !Shopify.designMode) return;
  try {
    
  // Criando componente personalizado para o slider caso não exista
  if (customElements.get('slider-component') === undefined) {
    customElements.define(
      'slider-component',
      class SliderComponent extends HTMLElement {
        constructor() {
          super();
          this.slider = this.querySelector('[id^="Slider-"]');
          this.sliderItems = this.querySelectorAll('.slider__slide');
          this.prevButton = this.querySelector('.slider-button--prev');
          this.nextButton = this.querySelector('.slider-button--next');
          this.currentPageElement = this.querySelector('.slider-counter--current');
          this.totalPagesElement = this.querySelector('.slider-counter--total');

          if (!this.slider || !this.nextButton) return;

          this.initPages();

          this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
          this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
        }

        initPages() {
          this.slidesPerPage = this.getAttribute('data-slides-per-view')
            ? parseInt(this.getAttribute('data-slides-per-view'))
            : 1;
          this.totalPages = Math.ceil(this.sliderItems.length / this.slidesPerPage);
          this.update();
        }

        update() {
          if (!this.currentPageElement || !this.totalPagesElement) return;
          this.currentPage = Math.floor(this.slider.scrollLeft / this.slider.offsetWidth) + 1;
          this.currentPageElement.textContent = this.currentPage;
          this.totalPagesElement.textContent = this.totalPages;
        }

        onButtonClick(event) {
          event.preventDefault();
          const step = event.currentTarget.dataset.step || 1;
          this.slideScrollPosition =
            event.currentTarget.name === 'next'
              ? this.slider.scrollLeft + this.slider.offsetWidth
              : this.slider.scrollLeft - this.slider.offsetWidth;

          this.slider.scrollTo({
            left: this.slideScrollPosition,
            behavior: 'smooth',
          });

          setTimeout(() => {
            this.update();
          }, 400);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
